var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClassResults(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1753_60590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.851562 11.0448L13.6192 4.23535L26.3869 11.0448L13.6192 17.8542L0.851562 11.0448Z",
    stroke: "black",
    strokeWidth: 1.70236,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.003 26.372V14.4555L13.6191 11.0508",
    stroke: "black",
    strokeWidth: 1.70236,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4091 12.6348V18.4441C23.4084 18.6248 23.3486 18.8004 23.2389 18.9441C22.526 19.9017 19.5043 23.3915 13.6206 23.3915C7.73681 23.3915 4.71513 19.9017 4.00227 18.9441C3.89257 18.8004 3.8328 18.6248 3.83203 18.4441V12.6348",
    stroke: "black",
    strokeWidth: 1.70236,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1753_60590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.2377,
    height: 27.2377,
    fill: "white",
    transform: "translate(0 0.835938)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassResults);
export default __webpack_public_path__ + "static/media/ClassResults.bb357e6c32f48576ff3491213bf3e551.svg";
export { ForwardRef as ReactComponent };